"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSession = getSession;
exports.createSSOToken = createSSOToken;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

function getSession(_x, _x2) {
  return _getSession.apply(this, arguments);
}

function _getSession() {
  _getSession = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(ssoToken, preCreated) {
    return _regenerator.default.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              var _context, _context2;

              return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(base, "/v1/sso?token=")).call(_context2, encodeURIComponent(ssoToken), "&pre-created=")).call(_context, preCreated ? 'true' : 'false');
            }).then( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                return _regenerator.default.wrap(function _callee$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", fetch(url, {
                          cache: 'force-cache',
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x5) {
                return _ref.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                return _regenerator.default.wrap(function _callee2$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x6) {
                return _ref2.apply(this, arguments);
              };
            }()).then(function (response) {
              return response.LongToken;
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));
  return _getSession.apply(this, arguments);
}

function createSSOToken(_x3, _x4) {
  return _createSSOToken.apply(this, arguments);
}

function _createSSOToken() {
  _createSSOToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(vertical, path) {
    return _regenerator.default.wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", (0, _environment.getRoute)('SecurityServices').then(function (base) {
              return "".concat(base, "/v1/sso");
            }).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(url) {
                return _regenerator.default.wrap(function _callee4$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        return _context6.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)({
                            Vertical: vertical,
                            Path: path
                          }),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x7) {
                return _ref3.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(response) {
                return _regenerator.default.wrap(function _callee5$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x8) {
                return _ref4.apply(this, arguments);
              };
            }()).then(function (response) {
              return response.Url;
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee6);
  }));
  return _createSSOToken.apply(this, arguments);
}
